var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhirlpoolStepperInformationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1427 24.5995L12.1934 25.3062L12.9 20.3568L25.6281 7.62869C26.1907 7.06607 26.9538 6.75 27.7495 6.75C28.5451 6.75 29.3082 7.06607 29.8708 7.62869C30.4334 8.19131 30.7495 8.95438 30.7495 9.75004C30.7495 10.5457 30.4334 11.3088 29.8708 11.8714L17.1427 24.5995Z",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7501 0.75H7.75001C7.19772 0.75 6.75 1.19772 6.75 1.75001V3.75002C6.75 4.30231 7.19772 4.75003 7.75001 4.75003H15.7501C16.3024 4.75003 16.7501 4.30231 16.7501 3.75002V1.75001C16.7501 1.19772 16.3024 0.75 15.7501 0.75Z",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 2.75H20.75C21.2805 2.75 21.7892 2.96072 22.1643 3.33579C22.5393 3.71087 22.75 4.21958 22.75 4.75002",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7502 24.7502V28.7502C22.7502 29.2806 22.5395 29.7893 22.1644 30.1644C21.7893 30.5395 21.2806 30.7502 20.7502 30.7502H2.75002C2.21958 30.7502 1.71087 30.5395 1.33579 30.1644C0.960715 29.7893 0.75 29.2806 0.75 28.7502V4.75002C0.75 4.21958 0.960715 3.71087 1.33579 3.33579C1.71087 2.96072 2.21958 2.75 2.75002 2.75H6.75005",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.75H16.7501",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 16.75H10.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhirlpoolStepperInformationIcon);
export default __webpack_public_path__ + "static/media/whirlpool-stepper-information-icon.69523c765b773ff8030133f9383abb74.svg";
export { ForwardRef as ReactComponent };